import { border, height } from "@mui/system";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";

import { ContextMenuTrigger } from "react-contextmenu";
import { Button } from '@carbon/react'
// import { selectRecords, selectSelectedChannel, selectSelectedRecordId, setSelectedRecordId } from "../../RecordSlice";
import { ITimelineItem } from "../../inputs/Timeline/Timeline.model";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { selectSelectedChannel, selectSelectedRecordId, setSelectedRecordId } from "../../../AppSlice";
import { colorFromString, formatDateTime } from "../../../helper";
import Icon from "../../Icon/Icon";
// import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
// import { selectChangeStamp } from "../../../Calendar/CalendarSlice";
// import { colorFromString, formatDateTime } from "../../../../../helper";
// import { selectNow } from "../../../../../AppSlice";
// import { ITimelineItem } from "../../../../PanelComponents/Timeline/Timeline.model";

interface IProps {
    item: ITimelineItem;
    day: string;
    isBackup?: boolean;
    isEdited?: boolean;
    hoursBeforeDay?: number;
    hoursAfterDay?: number;
    onMouseDown: (id: string) => void;
}

interface IOverlay { id: string; start: number; end: number }

export default function RecordItem({ item, day, isBackup, isEdited, onMouseDown, hoursBeforeDay = 0, hoursAfterDay = 0 }: IProps) {

    const [startPer, setStartPerc] = useState(null)
    const [endPer, setEndPerc] = useState(null)
    const [divStyle, setDivStyle] = useState<React.CSSProperties>(null)
    const [itemWidth, setItemWidth] = useState<number>(1)
    const selectedCalId = useAppSelector(selectSelectedRecordId)
    // const calItems = useAppSelector(selectRecords)
    // const selectedDragCalId = null // useAppSelector(selectDragItemId)
    // const changeStamp = useAppSelector(selectChangeStamp)
    // const [overlays, setOverlays] = useState<IOverlay[]>([])
    const deletedItems = [] //useAppSelector(selectDeletedItems)
    const now = "" //useAppSelector(selectNow)
    const selectedChannel = useAppSelector(selectSelectedChannel)

    const dispatch = useAppDispatch()

    const calcStartPerc = () => {
        let c = (moment.utc(moment.utc(item?.start).local().format("YYYY-MM-DD HH:mm:ss")).unix() - moment.utc(day).startOf("day").subtract(selectedChannel && selectedChannel !== "ACTIVE" ? 0 : (hoursBeforeDay), 'hours').unix()) / (60 * 60 * (24 + (selectedChannel && selectedChannel !== "ACTIVE" ? 0 : (hoursBeforeDay + hoursAfterDay)))) * 100
        if (c > 120) return null
        return c
    }

    const calcEndPerc = () => {
        let c = (moment.utc(moment.utc(item?.start).local().format("YYYY-MM-DD HH:mm:ss")).unix() + (item?.length) - moment.utc(day).startOf("day").subtract(selectedChannel && selectedChannel !== "ACTIVE" ? 0 : (hoursBeforeDay), 'hours').unix()) / (60 * 60 * (24 + (selectedChannel && selectedChannel !== "ACTIVE" ? 0 : (hoursBeforeDay + hoursAfterDay)))) * 100
        if (c < -20) return null
        return c
    }

    const contentRef = useRef(null)

    // const rect = contentRef.current?.getBoundingClientRect()

    useEffect(() => {
        setStartPerc(calcStartPerc())
        setEndPerc(calcEndPerc())
    }, [item?.start, item?.end, day, ]) //changeStamp, now

    // useEffect(() => {
    //     setOverlays(calcOverlays())
    // }, [item?.options?.items, item?.options?.asset?.overlays, item?.options?.live?.overlays, item?.length, day, changeStamp])

    useEffect(() => {
        setItemWidth(endPer - startPer)
        setDivStyle(itemDiv(startPer, endPer))
    }, [startPer, endPer, ]) //changeStamp

    const showItemDetails = () => {
        //conlog("qqqq", item?.id);
        dispatch(setSelectedRecordId(item?.id))
        // let event = events.find(citem => citem.id === item?.id) ?? emptyCalendarItem
        // dispatch(setNewEvent(event))
    }

    const calcBackgroundColor = (): string => {
        let isSelected = selectedCalId === item?.id
        if (isEdited) { return isSelected ? '#00115e' : '#000233' }
        if (item?.status === "2") { return isSelected ? '#005e11' : '#003302' }
        // if (item?.status === "-2") { return isSelected ? '#5e1100' : '#330200' }
        // if (item?.status === "1") { return isSelected ? '#555500' : '#414100' }
        // if (item?.status === "2") { return isSelected ? '#005e11' : '#003302' }
        // if (item?.status === "3") { return isSelected ? '#121212' : '#020202' }
        // let nowunix = moment.utc(now).unix()
        // let startunix = moment.utc(item?.start).unix()
        // let endunix = moment.utc(item?.start).add(item?.length, "seconds").unix()
        // let isPlaying = startunix < nowunix && endunix > nowunix
        // if(isPlaying) return isSelected? '#005e11' : '#003302'
        return isSelected ? '#4e4e4e' : '#2b2b2b'
    }

    const itemDiv = (start: number, end: number): React.CSSProperties => {
        return {
            position: 'absolute',
            left: `${start}%`,
            top: 0,
            width: `${end - start}%`,
            // minWidth: '10px',
            height: '100%',
            padding: '5px',
            border: '1px solid rgba(0,0,0,0.1)',
            borderBottom: `2px solid ${colorFromString(item.id)}`,
            backgroundColor: calcBackgroundColor(),
            color: 'white',
            whiteSpace: 'nowrap',
            // borderColor: selected ? 'red' : 'white',
            textAlign: 'left',
            overflow: 'hidden',
            textAlignLast: 'left',
            opacity: deletedItems?.includes(item.id) ? 0.3 : 1,
        }
    }

    // const overlayDiv = (start: number, end: number): React.CSSProperties => {
    //     return {
    //         position: 'absolute',
    //         left: `${start}%`,
    //         bottom: 1,
    //         width: `${end}%`,
    //         // minWidth: '10px',
    //         height: 2,
    //         backgroundColor: "#aa2",
    //         overflow: 'hidden',
    //     }
    // }

    const handleMouseMove = (e) => {
        // if (selectedDragCalId && selectedDragCalId !== item?.id) {
        //     let pos = (e.clientX - rect?.x) / rect?.width * 100;
        //     if (pos > 50) {
        //         dispatch(dragItem({ id: selectedDragCalId, start: moment(moment.utc(item?.start).unix() + (item?.length)).toISOString(), channel: item.channel }))
        //     } else {
        //         let it = calItems[selectedDragCalId]
        //         if (it) dispatch(dragItem({ id: selectedDragCalId, start: moment(moment.utc(item?.start).unix() - (it.length)).toISOString(), channel: item.channel }))
        //     }
        // }
    }

    if ((!startPer && startPer !== 0) || (!endPer && endPer !== 0)) return null

    return <ContextMenuTrigger id={item?.id}>
        <div style={divStyle} ref={contentRef} onMouseDown={e => onMouseDown(item?.id)} onDoubleClick={e => showItemDetails()} onMouseMove={handleMouseMove}>
            {/* <div style={{ zIndex: 0 , position: "absolute", left: 0, top: 0, height: "100%", display: "flex", width: (item.playlistLength / item.length * 100).toString() + "%" }}>
                {item.options?.items?.map(it => <div style={{ backgroundColor: "rgba(255,255,255,0.15)", width: ((it.mark_out - it.mark_in) / item.playlistLength * 100).toString() + "%", borderRight: "1px dotted #999" }} />)}
            </div> */}
            <div style={{ position: "sticky", zIndex: 1 }}>
                {/* {item?.lastSubmit ? <span style={{ padding: 1, marginRight: 1 }}> <Icon type="check" color="green" size={11} /> </span> : null} */}
                {/* {item?.itemType === "playlist" && item?.length - item?.playlistLength ? <span style={{ padding: 0, marginRight: 1, fontSize: 12 }}><Icon type="warning" size={12} color="yellow" /> <span style={{ padding: 2 }}></span></span> : null} */}
                {/* {item?.length - item?.playlistLength > 0 ? "GAP!" : "Overlap!"} */}
                <strong>{item?.title}</strong>
                {/* <span style={{ fontSize: 11, marginLeft: 10 }}>{profileNames?.find(profile => profile.id === (isBackup ? item?.options.backupPreset : item?.options.encodePreset))?.title}</span> */}
            </div>
            <div style={{ position: "absolute", bottom: 7, left: 5, display: 'flex' }}>
                <div style={{ marginRight: 5 }}>
                    {formatDateTime(item?.start, "HH:mm")}
                </div>
            </div>
            <div style={{ position: "absolute", bottom: 7, right: 5 }}>
                {moment.utc(item?.end ?? now).local().format("HH:mm")}
            </div>
            {/* {!isEdited && item?.status !== "3" && item?.id !== "new_0" ? <div style={{ position: "absolute", bottom: -3, left: 50, width: "100%", textAlign: "center", zIndex: 2 }}>
                <ElementalControls onClick={action => dispatch(elementalItemAction({ calItemId: item?.id, action }))} />
            </div> : null} */}
            <div style={{ position: "absolute", top: -5, right: 0, zIndex: 2 }}>
                <Button kind="ghost" size='sm'  className='cds--btn--icon-only' onClick={e => showItemDetails()} >
                     <Icon size={13} type='settings' />
                </Button>
            </div>
            {/* {overlays?.map(overlay => <div key={overlay.id} style={overlayDiv(overlay.start, overlay.end)} />)} */}
            {/* <CalendarItemInfo item={item} /> */}
            {/* <ItemContextMenu item={item} day={day} /> */}
        </div>
    </ContextMenuTrigger>
}
